export enum AddDomainToBasketType {
  DOMAINS = 'DOMAINS',
  TRANSFERS = 'TRANSFERS',
  BACK_ORDER = 'BACK_ORDER',
}
